import { useCallback } from 'react';

interface SliderProps {
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
    formatValue?: (value: number) => string;
    step?: number;
}

export function Slider({
    min,
    max,
    value,
    onChange,
    formatValue = (val) => val.toString(),
    step = 1
}: SliderProps) {
    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(e.target.value);
        onChange(newValue);
    }, [onChange]);

    const sliderClassName = "w-full h-2 appearance-none cursor-pointer \
    bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200 \
    rounded-lg \
    [&::-webkit-slider-thumb]:appearance-none \
    [&::-webkit-slider-thumb]:h-4 \
    [&::-webkit-slider-thumb]:w-4 \
    [&::-webkit-slider-thumb]:rounded-full \
    [&::-webkit-slider-thumb]:bg-gradient-to-r \
    [&::-webkit-slider-thumb]:from-indigo-500 \
    [&::-webkit-slider-thumb]:to-purple-500 \
    [&::-webkit-slider-thumb]:shadow-md \
    [&::-webkit-slider-thumb]:cursor-pointer \
    [&::-moz-range-thumb]:appearance-none \
    [&::-moz-range-thumb]:h-4 \
    [&::-moz-range-thumb]:w-4 \
    [&::-moz-range-thumb]:rounded-full \
    [&::-moz-range-thumb]:bg-gradient-to-r \
    [&::-moz-range-thumb]:from-indigo-500 \
    [&::-moz-range-thumb]:to-purple-500 \
    [&::-moz-range-thumb]:border-0 \
    [&::-moz-range-thumb]:shadow-md \
    [&::-moz-range-thumb]:cursor-pointer";

    return (
        <div className="pt-2">
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={handleChange}
                className={sliderClassName}
            />
            <div className="mt-2 flex justify-between text-sm text-gray-600">
                <span>{formatValue(min)}</span>
                <span>{formatValue(value)}</span>
                <span>{formatValue(max)}</span>
            </div>
        </div>
    );
} 